import styled from 'styled-components';

const Column = styled.div<{
  alignItems?: string;
  borderColor?: string;
  borderWidth?: string;
  flex?: string;
  height?: string;
  justifyContent?: string;
  margin?: string;
  padding?: string;
  position?: string;
}>`
  display: flex;
  flex-direction: column;
  ${({ borderWidth, borderColor }) =>
    borderWidth &&
    `border-width: ${borderWidth};
    border-style: solid;
    border-color: ${borderColor || 'black'};`}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ padding }) => padding && `padding: ${padding};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ flex }) => flex && `flex: ${flex};`}
  ${({ position }) => position && `position: ${position};`}
`;

export { Column };
